export const Svg_086 = () => (
  <svg  style={{ width: '70px' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 70">
    <defs>
      <linearGradient
        id="a"
        x1={43.5}
        x2={10.6}
        y1={1.7}
        y2={48.7}
        data-name="Gradiente sem nome"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={54.7}
        x2={48.8}
        y1={48.5}
        y2={56.8}
        data-name="Gradiente sem nome 2"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={52.7}
        x2={50.7}
        y1={59}
        y2={61.9}
        data-name="Gradiente sem nome 3"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={52.7}
        x2={50.7}
        y1={43.3}
        y2={46.2}
        data-name="Gradiente sem nome 4"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={47.3}
        x2={45.1}
        y1={56.6}
        y2={59.7}
        data-name="Gradiente sem nome 5"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={58.4}
        x2={56.2}
        y1={45.5}
        y2={48.6}
        data-name="Gradiente sem nome 6"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={57.9}
        x2={57.9}
        y1={45.4}
        y2={45.4}
        data-name="Gradiente sem nome 7"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={44.8}
        x2={43}
        y1={51.4}
        y2={53.9}
        data-name="Gradiente sem nome 8"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={60.4}
        x2={58.7}
        y1={51.4}
        y2={53.9}
        data-name="Gradiente sem nome 9"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="j"
        x1={46.8}
        x2={45.5}
        y1={46.1}
        y2={48}
        data-name="Gradiente sem nome 10"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
      <linearGradient
        id="k"
        x1={57.9}
        x2={56.6}
        y1={57.2}
        y2={59.1}
        data-name="Gradiente sem nome 11"
        gradientTransform="matrix(1 0 0 -1 0 71.2)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
    </defs>
    <path
      d="M55 61.3v-.5c-2.6-3.6-6.7-5.9-11.2-6.2v-2.1C48.4 52 52 47.9 52 43c0-1.3-.4-2.5-1.1-3.5l-7.3-11c-.2-.3-.5-.5-.8-.5s-.7.2-.8.5l-7.3 11c-.7 1-1.1 2.2-1.1 3.5 0 4.9 3.6 9 8.2 9.5v2.1c-3 .2-5.8 1.3-8.2 3-1.4-1.1-2.9-2.1-4.6-2.7-1.7-.7-3.5-1-5.3-1.2v-6.5c2.5-.3 4.9-1.6 6.7-3.7 2-2.3 3.2-5.5 3.2-8.8s-.4-3.1-1.2-4.5l-8.9-14.9c-.2-.3-.5-.5-.9-.5s-.7.2-.9.5l-8.9 14.9c-.8 1.4-1.2 4.4-1.2 4.5 0 3.3 1.1 6.4 3.2 8.8 1.9 2.2 4.3 3.4 6.9 3.7v6.5c-2.5.1-5 .8-7.2 1.9-2.4 1.2-4.4 3-5.8 5.2 0 0 0 .2-.1.2v.3c0 .6.5 1 1 1h45Zm-3.1-1.5H36.1c-.3-.5-.7-.9-1.1-1.3 2.2-1.6 4.9-2.5 7.7-2.5s6.8 1.4 9.2 3.8ZM35.6 42.5c0-.9.3-1.7.7-2.4l6.4-9.7 6.4 9.7c.5.7.7 1.5.7 2.4 0 3.8-2.7 6.9-6.1 7.4v-3.7l3.8-3.8c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-2.4 2.4v-8.2c0-.6-.5-1-1-1s-1 .5-1 1v8.2L39.3 41c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l3.8 3.8v3.7c-3.5-.5-6.1-3.6-6.1-7.4Zm-22-8.2c.1-.8.5-2.8 1-3.5l8-13.4 8 13.4c.5.8.8 2.7 1 3.5 0 5.3-3.4 9.6-7.8 10.3v-3.5l3.8-3.8c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-2.4 2.4v-4.6l3.8-3.8c.4-.5.4-1.1 0-1.5s-1.1-.4-1.4 0l-2.4 2.4v-6.7c0-.6-.5-1-1-1s-1 .5-1 1v6.7l-2.4-2.4c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3.8 3.8v4.6l-2.4-2.4c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3.8 3.8v3.5c-4.5-.5-8-5-8.1-10.3Zm8.9 20.9c3.9 0 7.6 1.4 10.3 3.9.2.2.4.4.6.7H11.6c2.7-2.9 6.7-4.6 10.9-4.6Z"
      style={{
        fill: "url(#a)",
      }}
    />
    <path
      d="M51.7 13.5c-2.8 0-5.1 2.3-5.1 5.1s2.3 5.1 5.1 5.1 5.1-2.3 5.1-5.1-2.3-5.1-5.1-5.1Zm0 8.1c-1.7 0-3.1-1.4-3.1-3.1s1.4-3.1 3-3.1 3.1 1.4 3.1 3.1-1.4 3-3 3.1Z"
      style={{
        fill: "url(#b)",
      }}
    />
    <path
      d="M51.7 12.6c.6 0 1-.5 1-1V9.8c0-.6-.5-1-1-1s-1 .5-1 1v1.8c0 .6.5 1 1 1Z"
      style={{
        fill: "url(#c)",
      }}
    />
    <path
      d="M51.7 28.4c.6 0 1-.5 1-1v-1.8c0-.6-.5-1-1-1s-1 .5-1 1v1.8c0 .6.5 1 1 1Z"
      style={{
        fill: "url(#d)",
      }}
    />
    <path
      d="M46.1 14.4c.2.2.5.3.7.3.3 0 .5-.1.7-.3.4-.4.4-1 0-1.4l-1.3-1.3c-.4-.3-1-.3-1.4 0-.4.4-.5 1 0 1.4l1.3 1.3Z"
      style={{
        fill: "url(#e)",
      }}
    />
    <path
      d="M57.4 22.8c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l1.3 1.3c.2.2.5.3.7.3s.5-.1.7-.3c.4-.4.4-1 0-1.4l-1.3-1.3Z"
      style={{
        fill: "url(#f)",
      }}
    />
    <path
      d="M57.9 25.8z"
      style={{
        fill: "url(#g)",
      }}
    />
    <path
      d="M43 19.6h1.9c.6 0 1-.5 1-1s-.5-1-1-1H43c-.6 0-1 .5-1 1s.5 1 1 1Z"
      style={{
        fill: "url(#h)",
      }}
    />
    <path
      d="M60.5 17.5h-1.9c-.6 0-1 .5-1 1s.5 1 1 1h1.9c.6 0 1-.5 1-1s-.5-1-1-1Z"
      style={{
        fill: "url(#i)",
      }}
    />
    <path
      d="M44.5 24.8c0 .6.5 1 1 1s.5-.1.7-.3l1.3-1.3c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-1.3 1.3c-.2.2-.3.5-.3.7Z"
      style={{
        fill: "url(#j)",
      }}
    />
    <path
      d="M56.7 14.7c.3 0 .5-.1.7-.3l1.3-1.3c.3-.4.3-1 0-1.4-.4-.4-1-.5-1.4 0L56 13c-.2.2-.3.4-.3.7 0 .6.5 1 1 1Z"
      style={{
        fill: "url(#k)",
      }}
    />
  </svg>
)